import { css } from '@emotion/react';
import { Outlet } from 'react-router-dom';

import useScrollReset from '~/common/hooks/useScrollReset';

import type { PropsWithChildren } from 'react';

function EmptyLayout({ children }: PropsWithChildren) {
  useScrollReset();
  return (
    <div css={styles.emptyLayout}>
      <main>{children || <Outlet />}</main>
    </div>
  );
}

const styles = {
  emptyLayout: css`
    position: relative;
    width: 100vw;
    height: 100vh;

    main {
      min-height: 100vh;
    }
  `,
};

export default EmptyLayout;
